import {Alert, Space} from "antd";
import {OfferingFormAccordionItem} from "../../accordion/accordion-item";
import {LiveEventCohostFormFieldsProps} from "./types";
import {FullPageLoader} from "../../../full-page-loader";
import {useFetchCoHosts} from "../../../../react-query-hooks/live-events/co-hosts/co-hosts";
import {CohostList} from "./cohost-list";

export function LiveEventCohostFormFields({
  liveEventData,
}: LiveEventCohostFormFieldsProps) {
  const fetchClassCoHostsQuery = useFetchCoHosts(String(liveEventData?.id));
  if (fetchClassCoHostsQuery.isLoading) {
    return <FullPageLoader />;
  }

  if (fetchClassCoHostsQuery.isError) {
    return (
      <Alert
        message="Error"
        description={fetchClassCoHostsQuery.error.message}
        type="error"
        showIcon
      />
    );
  }
  return (
    <Space direction="vertical" size={16} style={{display: "flex"}}>
      <OfferingFormAccordionItem key={"Add co-host"} index={0} title={"Add co-host"}>
        <CohostList coHosts={fetchClassCoHostsQuery.data} eventId={liveEventData?.id} />
      </OfferingFormAccordionItem>
    </Space>
  );
}
